<template>
  <v-container fluid class="pa-0">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title>
        {{ $t("documentation.subtitle3") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('documentation.search_placeholder')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
        class="mx-1"
        clearable
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        :href="pdfHref"
        download="MappaTerminiPerLaRicerca.pdf"
        color="grey-darken-4"
        variant="flat"
        class="ml-2"
      >
        <v-icon start>mdi-download</v-icon>
        <span class="hidden-sm-and-down">{{
          $t("documentation.download_pdf")
        }}</span>
      </v-btn>
    </v-app-bar>

    <v-data-table
      :headers="headers"
      :items="terms"
      :search="search"
      item-value="id"
      :items-per-page="50"
      :items-per-page-options="[
        { value: 25, title: '25' },
        { value: 50, title: '50' },
        { value: 100, title: '100' },
        { value: -1, title: $t('documentation.all_rows') },
      ]"
      density="compact"
      hover
      class="search-terms-table elevation-1 pb-12"
    >
      <template #item.groupId="{ item }">
        <span v-html="highlightMatch(item.groupId)" />
      </template>
      <template #item.groupName="{ item }">
        <span v-html="highlightMatch(item.groupName)" />
      </template>
      <template #item.title="{ item }">
        <span v-html="highlightMatch(item.title)" />
      </template>
      <template #item.synonym1="{ item }">
        <span v-html="highlightMatch(item.synonym1)" />
      </template>
      <template #item.synonym2="{ item }">
        <span v-html="highlightMatch(item.synonym2)" />
      </template>
      <template #item.synonym3="{ item }">
        <span v-html="highlightMatch(item.synonym3)" />
      </template>
      <template #no-data>
        <div class="pa-4 text-medium-emphasis">
          {{ $t("documentation.no_results") }}
        </div>
      </template>
    </v-data-table>
    <v-btn
      v-show="showScrollTop"
      icon
      class="scroll-top-btn"
      color="#F44336"
      @click="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import searchTerms from "@/data/searchTermsMap.json";

export default {
  name: "SearchTerms",
  data: () => ({
    search: "",
    pdfHref: "/MappaTerminiPerLaRicerca.pdf",
    terms: searchTerms,
    showScrollTop: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    headers() {
      return [
        {
          title: this.$t("documentation.col_group_id"),
          key: "groupId",
          width: "110px",
        },
        {
          title: this.$t("documentation.col_group"),
          key: "groupName",
        },
        {
          title: this.$t("documentation.col_title"),
          key: "title",
        },
        {
          title: this.$t("documentation.col_synonym1"),
          key: "synonym1",
        },
        {
          title: this.$t("documentation.col_synonym2"),
          key: "synonym2",
        },
        {
          title: this.$t("documentation.col_synonym3"),
          key: "synonym3",
        },
      ];
    },
  },
  methods: {
    escapeHtml(text) {
      return String(text ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },
    highlightMatch(text) {
      const escaped = this.escapeHtml(text);
      const term = (this.search || "").trim();
      if (!term) return escaped;
      const safeTerm = term.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
      return escaped.replace(new RegExp(`(${safeTerm})`, "gi"), "<mark>$1</mark>");
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.search-terms-table :deep(thead th) {
  font-weight: 700 !important;
  color: #212121 !important;
  border: 1px solid #9e9e9e !important;
}
.search-terms-table :deep(td) {
  border: 1px solid #bdbdbd !important;
}
.search-terms-table :deep(thead th:nth-child(1)) {
  background: #fff59d !important;
}
.search-terms-table :deep(tbody td:nth-child(1)),
.search-terms-table :deep(tbody td:nth-child(3)) {
  background: #fff !important;
}
.search-terms-table :deep(thead th:nth-child(2)),
.search-terms-table :deep(tbody td:nth-child(2)) {
  background: #c5e1a5 !important;
}
.search-terms-table :deep(thead th:nth-child(3)) {
  background: #ffee58 !important;
}
.search-terms-table :deep(thead th:nth-child(4)),
.search-terms-table :deep(thead th:nth-child(5)),
.search-terms-table :deep(thead th:nth-child(6)),
.search-terms-table :deep(tbody td:nth-child(4)),
.search-terms-table :deep(tbody td:nth-child(5)),
.search-terms-table :deep(tbody td:nth-child(6)) {
  background: #e1bee7 !important;
}
.search-terms-table :deep(mark) {
  background: #ffeb3b;
  color: #000;
  font-weight: 700;
  padding: 0 2px;
  border-radius: 2px;
}
.scroll-top-btn {
  position: fixed;
  bottom: 60px;
  right: 15px;
  z-index: 9999;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
}
</style>
